/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeDRadiusDownLeftIcon24Solid = forwardRef('ArrowShapeDRadiusDownLeftIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M11.999 20.551c0 1.203-1.454 1.805-2.305.955l-8.178-8.18a1.875 1.875 0 0 1 0-2.651l8.178-8.18c.85-.85 2.305-.247 2.305.955V7c1.8 0 3.18-.007 4.564-.453 1.37-.442 2.807-1.336 4.608-3.24.604-.638 1.777-.307 1.814.673.168 4.415-1.09 7.691-3.219 9.865-2.064 2.107-4.872 3.1-7.767 3.153v3.553Z" })));
});
